import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function TerritoryUpsert(param: any) {

    let [Territory, setTerritory] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            Territory = param?.editDataDawer
            setTerritory(Territory)
        }
    }

    const onSave = () => {
        /*systemFormatsList.saveStatusAccount(Territory).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })*/
    }

    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Territory</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">
                    <div className="ws-12">
                        <div className="ws-6">

                            <div className="form-format">
                                <label className="control-label" title="territoryCode">Territory Code*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Territory Code" value={Territory?.territoryCode ?? ""} onChange={(e: any) => setTerritory({ ...Territory, territoryCode: e.target.value })} required id="territoryCode" name="territoryCode" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="territoryName">Territory Name*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Territory Name" value={Territory?.territoryName ?? ""} onChange={(e: any) => setTerritory({ ...Territory, territoryName: e.target.value })} required id="territoryName" name="territoryName" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="territoryCurrency">Territory Currency</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Territory currency" value={Territory?.territoryCurrency ?? ""} onChange={(e: any) => setTerritory({ ...Territory, territoryCurrency: e.target.value })} id="territoryCurrency" name="territoryCurrency" />
                                </div>
                            </div>

                        </div>

                        <div className="ws-6">

                            <div className="form-format">
                                <label className="control-label" title="dim1TerritoryCodes">DIM1</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter DIM1 Territory Code" value={Territory?.dim1TerritoryCodes ?? ""} onChange={(e: any) => setTerritory({ ...Territory, dim1TerritoryCodes: e.target.value })} id="dim1TerritoryCodes" name="dim1TerritoryCodes" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="dim2TerritoryCodes">DIM2</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter DIM2 Territory Code" value={Territory?.dim2TerritoryCodes ?? ""} onChange={(e: any) => setTerritory({ ...Territory, dim2TerritoryCodes: e.target.value })} id="dim2TerritoryCodes" name="dim2TerritoryCodes" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="dim3TerritoryCodes">DIM3</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter DIM3 Territory Code" value={Territory?.dim3TerritoryCodes ?? ""} onChange={(e: any) => setTerritory({ ...Territory, dim3TerritoryCodes: e.target.value })} id="dim3TerritoryCodes" name="dim3TerritoryCodes" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="systemRegion">System Region</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter System Region" value={Territory?.systemRegion ?? ""} onChange={(e: any) => setTerritory({ ...Territory, systemRegion: e.target.value })} id="systemRegion" name="systemRegion" />
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}